import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { setClient, setClientRecord } from "../../../store/slices/clientsSlice";
import { useLocation, useNavigate } from "react-router";
import clientsApi from "../../../api/clients";

const Clients = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const client_value = useSelector((state) => state.clients.selectedClient) ?? "hdfc";
  const client_record = useSelector((state) => state.clients.selectedClientRecord);
  const [tenantOptions, setTenantOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const navigate = useNavigate();

  // Fetch tenants once on mount
  useEffect(() => {
    clientsApi.getAllTenants().then((res) => {
      const tenants = Array.isArray(res?.data) ? res.data : [];
      setTenantOptions(
        tenants.map((t) => ({ label: t.tenantName, value: t.tenantId }))
      );
    }).catch(() => {});
  }, []);

  // Fetch clients whenever the selected tenant changes
  useEffect(() => {
    clientsApi.getAllClients({ searchQuery: "" }).then((res) => {
      const list = Array.isArray(res?.data?.clients) ? res.data.clients : (Array.isArray(res?.data) ? res.data : []);
      const mapped = list.map((c) => ({ label: c.client_name, value: c.slug_name, raw: c }));
      setClientOptions(mapped);
      // Auto-select the first client
      dispatch(setClientRecord(mapped.length > 0 ? mapped[0] : null));
    }).catch(() => {});
  }, [client_value]);

  const handleTenantChange = (event) => {
    dispatch(setClient(event));
    const path = location.pathname.split("/");
    navigate(`/pages/${path[2]}`)
  };

  const handleClientChange = (event) => {
    dispatch(setClientRecord(event));
    const path = location.pathname.split("/");
    navigate(`/pages/${path[2]}`)
  };

  useEffect(() => {
    navigate(location.pathname, { replace: true });
  }, [client_value,client_record]);

  return (
    <div className="d-flex align-items-center gap-2">
      <Select
        options={tenantOptions}
        value={client_value}
        placeholder="Select tenant..."
        className="js-example-basic-single"
        styles={{ container: (base) => ({ ...base, minWidth: 160 }) }}
        onChange={handleTenantChange}
      />
      <Select
        options={clientOptions}
        value={client_record}
        placeholder="Select client..."
        isClearable
        className="js-example-basic-single"
        styles={{ container: (base) => ({ ...base, minWidth: 180 }) }}
        onChange={handleClientChange}
      />
    </div>
  );
};

export default Clients;
